import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';

import { SedsOutlinedButtonModule } from '../seds-buttons';
import { SedsSnackbarComponent } from './seds-snackbar.component';
import { SedsSnackbarService } from './service/seds-snackbar.service';

@NgModule({
  declarations: [SedsSnackbarComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatSnackBarModule, SedsOutlinedButtonModule],
  exports: [SedsSnackbarComponent, MatSnackBarModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: MAT_SNACK_BAR_DATA, useValue: {} }, SedsSnackbarService],
})
export class SedsSnackbarModule {}
